import { CoreIcon } from '../core-icon';
import pointCircleColorSVG from '../../assets/icons/point-circle-color.svg';
import type { IconProps } from '../core-icon';

export const PointCircleColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={pointCircleColorSVG} {...props} />;
};
